import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import intelligentOutboundCallDetailsAPI from '../apis/intelligentOutboundCallDetailsAPI'
import alertMessage from '../utils/alertMessage'

export default class IntelligentOutboundCallDetailsStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0

  /*SearchResult start*/
  @observable searchItem = {
    'taskId': '',
    'callStatus': '',
    'calleeNo': '',
    'isPowerUser': false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await intelligentOutboundCallDetailsAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  // 详情
  @observable detailsObj = null
  @action
  async onGetStatus(params) {
    this.detailsObj = null
    try {
      const response = await intelligentOutboundCallDetailsAPI.getStatus(params)
      const {code, data, messageEn} = response?.data
      runInAction(() => {
        if (code === 0) {
          this.detailsObj = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      ...this.searchItem,
      'isPowerUser': this.searchItem.isPowerUser,
      'page': pageNo,
      'size': pageSize,
    })
  }
}
